import React from 'react';
import Component from 'components/Additions';
import {connect} from 'react-redux';
import withRouter from 'utils/withRouter';
import {newAdditions} from 'selectors/worksSelectors';


const Container = withRouter(connect(
	(state, ownProps) => ({
		router: state.router,
		works: newAdditions(state),
		id: state.works.id
	}),
	(dispatch, ownProps) => ({
		navigateTo: (location) => {
			if (ownProps.navigate) {
				ownProps.navigate(location);
			}
		}
	})
)(Component));
export default Container;